module.exports = __webpack_public_path__ + "static/lendlease_logo-5f59d722227b6ba70fc5d481e0ce51fc.png";